import { Data } from '@taraai/types';

// Not every installable service requires redirects to external websites
export type InstallableServiceWithRedirects = Extract<Data.InstallableService, 'github' | 'slack' | 'gitlabApp'>;

export function isInstallableServiceWithRedirects(data: string): data is InstallableServiceWithRedirects {
  return ['github', 'slack', 'gitlabApp'].some((service) => service === data);
}
